import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
  padding: ${space[4]};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: 12px;
`;

export const Label = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  flex: 1;
  min-width: 0;
`;
